import _isFunction from 'lodash-es/isFunction';
import _isString from 'lodash-es/isString';
import { BasicSystemError, WindowSystemAlreadyDefined } from './errors';
import { ExportOfBundle, ExportOfModule } from './types';
import { Schema } from './util/Schema';

export class SystemInvariant<
  BundleName extends string,
  ModuleName extends string,
  BundlesModules extends { [K in BundleName]: ModuleName },
  ModulesExport extends { [K in ModuleName]: any }
> {
  /**
   * Common
   */

  unreachable(): any {
    throw new BasicSystemError(`Invariant: unreachable reached...`);
  }

  notUndefined<T>(value: T | undefined): T {
    if (value === undefined) {
      throw new BasicSystemError(`Invariant: value is undefined`);
    }
    return value;
  }

  notNull<T>(val: T | null): T {
    if (val === null) {
      throw new BasicSystemError('Null ?');
    }
    return val;
  }

  isString(val: any): string {
    if (!_isString(val)) {
      throw new BasicSystemError('Not String ?');
    }
    return val;
  }

  isFunction<T>(val: T): T {
    if (!_isFunction(val)) {
      throw new BasicSystemError('Not Function ?');
    }
    return val;
  }

  isStringTyped<T extends string>(): (val: any) => T {
    return (val: any): T => this.isString(val) as any;
  }

  notFalse<T>(val: T | false): T {
    if (val === false) {
      throw new BasicSystemError('False ?');
    }
    return val;
  }

  elementById(id: string): HTMLElement {
    const elem = document.getElementById(id);
    return this.notNullElement(elem);
  }

  notNullElement(val: HTMLElement | null): HTMLElement {
    if (val === null) {
      throw new BasicSystemError(`Val is null !`);
    }
    return val;
  }

  /**
   * System
   */

  windowSystemNotDefined(): void {
    if ((window as any).System !== undefined) {
      throw new WindowSystemAlreadyDefined();
    }
  }

  /**
   * Bundle
   */

  parseBundleResultValid<B extends BundleName>(
    bundleName: B,
    bundleExport: any
  ): ExportOfBundle<BundleName, ModuleName, BundlesModules, ModulesExport, B> {
    return Schema.validate<ExportOfBundle<BundleName, ModuleName, BundlesModules, ModulesExport, B>>(
      Schema.object<ExportOfBundle<BundleName, ModuleName, BundlesModules, ModulesExport, B>>({
        getCache: this.isFunction,
        modules: Schema.stringKeyedObject(this.isFunction),
      }),
      bundleExport
    );
  }

  /**
   * Module
   */

  moduleIsEsModule(module: any): module is ExportOfModule<ModuleName, ModulesExport, ModuleName> {
    if (!(module && module.__esModule === true)) {
      throw new BasicSystemError('Module is not an ESModule');
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./node_modules/front-system/engine/SystemInvariant.ts